export default __webpack_public_path__ + "static/media/other_white.cc23ef54.svg";